var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sw-grid-flex sw-grid-flex--dir-column",
      class: !_vm.materialId ? "sw-dms--color-grey-64" : ""
    },
    [
      _c(
        "table",
        [
          _vm._m(0),
          _vm._v(" "),
          !_vm.tariffCodes.length
            ? _c("tr", [
                _c("td", { attrs: { colspan: "4" } }, [
                  _vm._v("No tariff codes were found.")
                ])
              ])
            : _vm._l(_vm.materialTariffCodes, function(tariffCode, index) {
                return _c(
                  "tr",
                  {
                    key: "tariff-code-" + tariffCode.id,
                    class: index % 2 ? "even" : "odd"
                  },
                  [
                    _c("td", [_vm._v(_vm._s(tariffCode.description))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(tariffCode.countryName))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(tariffCode.tariffCode))]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              return _vm.deleteTariffCode(tariffCode.id)
                            }
                          }
                        },
                        [_vm._v("Remove")]
                      )
                    ])
                  ]
                )
              })
        ],
        2
      ),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _vm.materialId
        ? _c("table", [
            _vm._m(1),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("Description")]),
              _vm._v(" "),
              _c("td", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.description,
                      expression: "description",
                      modifiers: { trim: true }
                    }
                  ],
                  attrs: {
                    type: "text",
                    name: "description",
                    id: "description"
                  },
                  domProps: { value: _vm.description },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.description = $event.target.value.trim()
                    },
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("Country")]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.country,
                        expression: "country"
                      }
                    ],
                    attrs: { name: "country", id: "country" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.country = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "" } }),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "224" } }, [
                      _vm._v("United States")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "148" } }, [
                      _vm._v("Netherlands")
                    ])
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("Tariff Code")]),
              _vm._v(" "),
              _c("td", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.tariffCode,
                      expression: "tariffCode",
                      modifiers: { trim: true }
                    }
                  ],
                  attrs: {
                    type: "text",
                    name: "tariff-code",
                    id: "tariff-code"
                  },
                  domProps: { value: _vm.tariffCode },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.tariffCode = $event.target.value.trim()
                    },
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { attrs: { colspan: "2" } }, [
                _c(
                  "button",
                  {
                    class: !_vm.materialId
                      ? "disabled-button"
                      : "action-button",
                    on: { click: _vm.addTariffCode }
                  },
                  [_vm._v("Add\n                ")]
                )
              ])
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Description")]),
        _vm._v(" "),
        _c("th", [_vm._v("Country")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tariff Code")]),
        _vm._v(" "),
        _c("th", [_vm._v(" ")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { colspan: "2" } }, [_vm._v("Add Tariff Code")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }